import Backdrop from "@mui/material/Backdrop";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import URL from "../../common/api/ConstantURL";
import * as APIService from "../../common/api/index.js";
import { getSessionContext } from "../../common/utils/sessionContext";
import { removeManyFromLocalStorage, setManyToLocalStorage, setToLocalStorage } from "../../common/utils/localStorage";
import AlertMessage from "../../common/components/AlertMessage.js";
import Confirmation from "../../common/components/Confirmation.js";
import Header from "./Header";
import * as Sentry from "@sentry/react";

const Community = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [alertStatus, setAlertStatusBase] = useState("");
  const [communityList, setCommunityList] = useState([]);
  const [selectedCommunity, setSelectedCommunity] = useState(null);
  const [showTodoPopup, setShowTodoPopup] = useState(false);

  const RESIDENT_KEYS = ["ResidentInfo", "ResidentName", "ResidentId", "CaregiverCheckinId", "shiftId"];

  const navigate = useNavigate();
  const removeLocalStorageKeys = (keys = []) => {
    removeManyFromLocalStorage(keys);
  };

  const clearResidentContextForCommunitySwitch = () => {
    removeLocalStorageKeys(RESIDENT_KEYS);
  };

  const fetchCommunityDetailsList = async () => {
    setLoading(true);
    try {
      const { caregiverId } = getSessionContext();
      const responseData = await APIService.getData(URL.getCommunityListForCaregiver + "?caregiverId=" + caregiverId);

      if (responseData.status === "success") {
        const communities = responseData.data || [];
        if (communities.length === 1) {
          const community = communities[0];
          clearResidentContextForCommunitySwitch();

          setManyToLocalStorage({
            communityId: community.id,
            communityName: community.communityName,
            communityFlag: 0,
          });

          navigate("/home", { replace: true });
        } else {
          setToLocalStorage("communityFlag", 1);
          setCommunityList(communities);
        }
      } else {
        setAlertStatusBase({
          message: responseData.message,
          status: responseData.code,
          origin: "center",
        });
      }

      setLoading(false);
    } catch (error) {
      Sentry.captureException(error);
      setLoading(false);
      setAlertStatusBase({
        message: "Error while fetching communities",
        status: "400",
        origin: "center",
      });
    }
  };

  useEffect(() => {
    if (location.state?.communities) {
      setCommunityList(location.state.communities);
      return;
    }

    fetchCommunityDetailsList();
  }, []);

  const selectCommunityForCheckin = (community) => {
    setSelectedCommunity(community);
    setShowTodoPopup(true);
  };

  const confirmationCallback = (confirmed) => {
    setShowTodoPopup(false);

    if (confirmed && selectedCommunity) {
      clearResidentContextForCommunitySwitch(selectedCommunity.id);

      setManyToLocalStorage({
        communityFlag: 1,
        communityId: selectedCommunity.id,
        communityName: selectedCommunity.communityName,
      });

      navigate("/home");
    } else {
      setSelectedCommunity(null);
    }
  };

  return (
    <>
      <Header communities={communityList} />
      <Backdrop sx={{ color: "#ffba30", zIndex: (theme) => theme.zIndex.drawer + 1000 }} open={loading}>
        <img src={require("../../assets/btTree.png")} className="loading-img" alt="loading" />
      </Backdrop>
      {alertStatus && <AlertMessage status={alertStatus.status} message={alertStatus.message} origin={alertStatus.origin} closeAlert={() => setAlertStatusBase("")} />}
      <div className="community-select-wrapper">
        <div className="heading community-heading center-text">
          <p className="select-community-label">Select a Community</p>
        </div>
        <div className="community-button-container">
          {communityList.map((community) => (
            <button key={community.id} className="community-button col-8 col-lg-4" onClick={() => selectCommunityForCheckin(community)}>
              {community.communityName}
            </button>
          ))}
        </div>
      </div>
      <Confirmation username={selectedCommunity?.communityName || ""} content="Are you sure you want to select this community?" open={showTodoPopup} closeConfirmation={() => setShowTodoPopup(false)} processCallback={confirmationCallback} />
    </>
  );
};

export default Community;
